import en from "./en";
import zhCN from "./zh-CN";
import zhTW from "./zh-TW";

export default {
  en,
  zh_CN: zhCN,
  zh_TW: zhTW,
};

